"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var ListContainer_1 = require("./ListContainer");
require("./style.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('DistributionRecipients'), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement("div", { className: 'recipients-container', style: props.style },
        React.createElement(ListContainer_1.ListContainer, __assign({}, props, { distributionRecipients: props.distributionRecipients, errors: props.errors }))));
});
